import { render, staticRenderFns } from "./SimpleSpinner.vue?vue&type=template&id=e59d21c6&scoped=true"
import script from "./SimpleSpinner.vue?vue&type=script&lang=js"
export * from "./SimpleSpinner.vue?vue&type=script&lang=js"
import style0 from "./SimpleSpinner.vue?vue&type=style&index=0&id=e59d21c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59d21c6",
  null
  
)

export default component.exports